import React, {useCallback, useEffect, useState} from 'react'
import { Grid,
    Stack, Typography, Button
} from "@mui/material";
import { Loader } from "../../../../Components";
import {fetchStats} from "../Redux/Action";
import {useDispatch} from "react-redux";
import {useSelector} from "react-redux";
import {Treemap} from "./Widgets/TreeMap";
import dayjs from 'dayjs';
import {useSettings} from "../../../../Hooks/useSettings";
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';


export const DashboardManagement = () => {
    
    const dispatch = useDispatch();
    const theme = useTheme();
    const departments = useSelector(state => state.dashboard.departments);
    const [isConfigSet, setIsConfigSet] = useState(false);
    const { getSettingValue } = useSettings();
    const navigate = useNavigate();
    
    // Get current week date range based on settings
    const getCurrentWeekRange = () => {
        
        const startOfWeekSetting = getSettingValue('roster.roster.start_of_week', 'monday');
        
        // Map setting to dayjs day number (0=Sunday, 1=Monday, etc.)
        const dayMap = {
            'sunday': 0,
            'monday': 1,
            'tuesday': 2,
            'wednesday': 3,
            'thursday': 4,
            'friday': 5,
            'saturday': 6
        };
        
        const startDay = dayMap[String(startOfWeekSetting || '').toLowerCase()] || 1; // Default to Monday
        
        const today = dayjs();
        const startOfWeek = today.startOf('week').add(startDay, 'day');
        const endOfWeek = startOfWeek.add(6, 'day');
        
        return {
            start: startOfWeek.format('YYYY') !== endOfWeek.format('YYYY')
                ? startOfWeek.format('DD MMM YYYY')
                : startOfWeek.format('DD MMM'),
            end: endOfWeek.format('DD MMM YYYY'),
            startDate: startOfWeek.format('YYYY-MM-DD'),
            endDate: endOfWeek.format('YYYY-MM-DD')
        };
    };
    
    const weekRange = getCurrentWeekRange();

    const fetchData = useCallback(async () => {
        await fetchStats({dispatch, filters:{}}).then((res) => {
            if(res['success']){
                setIsConfigSet(true);
            }
        })
    },[ dispatch ]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        if(departments && departments.length > 0){
            setIsConfigSet(true);
        }
    }, [departments]);

    const DashboardContent = () => (
        <Grid container spacing={2} direction="row" justifyContent="top" alignItems="center">
            <Grid spacing={2} item container direction="row">
                <Grid item xs={12}>
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        sx={{ mx: { xs: 2, sm: 4, md: 8 }, background: '#f0f3f859', padding: '1rem', borderRadius: '0.5rem', border: '1px solid #d3eef5' }}
                        spacing={2}
                        alignItems={{ xs: 'stretch', sm: 'center' }}
                        justifyContent="space-between"
                    >
                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: 600,
                                textTransform: 'capitalize',
                                color: `${theme.palette.primary.dark}`,
                                fontSize: { xs: '1.1rem', sm: '1.5rem', md: '1.25rem' }
                            }}
                        >
                            Roster Coverage ({weekRange.start} - {weekRange.end})
                        </Typography>
                        <Button
                            variant="contained"
                            color="warning"
                            onClick={() => navigate('/dashboard/general')}
                            sx={{ flexShrink: 0, alignSelf: { xs: 'stretch', sm: 'center' } }}
                        >
                            Show Roster
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Treemap departments={departments} weekRange={weekRange} />
            </Grid>
        </Grid>
    );

    return (
        <>
            {isConfigSet ? (<DashboardContent />)
                : (
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" sx={{ height: '80vh' }}>
                        <Loader type="linear" height={3} label="Preparing Dashboard..." fontSize={28} />
                    </Grid>
                )}
        </>
    );
}
